document.addEventListener('DOMContentLoaded', function () {
  CF.ready(function () {
    const compatibilityTitle = document.querySelectorAll('.cf-field-container.js-accordion-title');
    const compatibilityContent = document.querySelectorAll('.cf-field-container.js-accordion-content');
    
    compatibilityTitle.forEach((title, index) => {
      if (compatibilityContent[index]) {
        title.appendChild(compatibilityContent[index]);
        compatibilityContent[index].style.display = 'grid';
        
        title.addEventListener('click', function (e) {
          if (e.target.closest('.js-accordion-content')) {
            return;
          }
          
          title.classList.toggle('is-active');
        });
      }
    });
  });
});